import request from '@/api'

// 创建换脸任务
export function createFaceSwapTask(data) {
  return request({
    url: '/task/faceswap',
    method: 'post',
    data
  })
}

// 创建视频翻译任务
export function createVideoTranslationTask(data) {
  return request({
    url: '/task/videotrans',
    method: 'post',
    data
  })
}

// 获取任务列表
export function getTaskList(params) {
  return request({
    url: '/task',
    method: 'get',
    params
  })
}

// 获取任务详情
export function getTaskDetail(taskId) {
  return request({
    url: `/task/${taskId}`,
    method: 'get'
  })
}

// 删除任务
export function deleteTask(taskId) {
  return request({
    url: `/task/${taskId}`,
    method: 'delete'
  })
}

// 计算任务所需信用值
export function calculateTaskCredits(data) {
  return request({
    url: '/task/calculateCredits',
    method: 'post',
    data
  })
}

// 创建字幕擦除任务
export function createSubtitleErasingTask(data) {
  return request({
    url: '/task/subtitleErasing',
    method: 'post',
    data
  })
}

// 获取我的任务统计情况
export function getMyTaskStatistics() {
  return request({
    url: '/task/my/static',
    method: 'get'
  })
}

// 创建文本提取任务
export function createExtractTextTask(data) {
  return request({
    url: '/task/extractText',
    method: 'post',
    data
  })
}

// 创建图片翻译任务
export function createImgFaceSwapTask(data) {
  return request({
    url: '/task/imgFaceSwap',
    method: 'post',
    data
  })
}

// 创建文本转语音任务
export function createTtsTask(data) {
  return request({
    url: '/task/tts',
    method: 'post',
    data
  })
}
